import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Common from '../../utilities/common';
import $ from "jquery";
import { DataGrid, GridRowSelectionModel, GridRowId, GridToolbar, GridCsvExportOptions, GridToolbarContainer, useGridApiContext, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector } from '@mui/x-data-grid';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import provincias from '../provincias.png';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import EntityPermissions from '../../components/EntityPermissions';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntitySettings from '../../components/EntitySettings';
import EditIcon from '@mui/icons-material/Edit';
import { TimerJobModel, TimerJobRunning } from './TimerJobModel';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ReactInterval from 'react-interval';

export interface IProvinciasState {
    data: TimerJobRunning[];
}

export default class TimerJobHistoryDetail extends React.Component<{}, IProvinciasState> {
    _file: any;
    _fileContent: any[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'Timer Jobs',
                            url: '/settings/jobs'
                        },
                        {
                            title: 'Historial',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <AvTimerOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Timer Jobs
                                </Typography>
                            </Grid>
                            <Grid item xs={2} className='entitySettings'>
                                <EntitySettings entity={Entity.Provincias}/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <DataGrid
                            autoHeight
                            hideFooter={this.state.data.length <= 30}
                            loading={this.state.data.length == 0}
                            rows={this.state.data}
                            columns={[
                                { 
                                    field: 'date', 
                                    headerName: 'Fecha', 
                                    width: 200,
                                    renderCell: ({ row }) => (
                                        Common.RenderDate(row, 'date')
                                    ) 
                                },
                                { 
                                    field: 'message', 
                                    headerName: 'Mensaje', 
                                    flex: 1
                                }
                            ]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 30 }
                                },
                            }}
                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                            pageSizeOptions={[30, 60, 100]}
                            checkboxSelection={false}
                        />
                    </Box>
                </Layout>
                <ReactInterval enabled={true} timeout={3000} callback={this.Get.bind(this)} />
            </SecurityTrimmer>
        )
    }

    private Get(): void {
        const id = Common.getUrlParam('id');
        let url = `${Common.END_POINT}/jobs/history/${id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response
                }
            );
        })
    }
}